export const FINALIZED_STATUSES = [
    'closed',
    'complete',
    'cancelled',
    'unnecessary',
    'canceled',
    'postponed',
    'suspended'
]

export const IN_PROGRESS_STATUSES = [
    'inprogress',
    'halftime',
    'intermission'
]